import { FunctionComponent, useContext, useEffect, useState } from 'react';
import { Button, Spinner } from '@chakra-ui/react';
import { InterestProviderListItem } from './interest-providers-list-item';
import { fetchInterestProviders } from './services/interest-prodviders-list-service';
import { convertFiltersToQueryString } from './utils';
import classNames from '../../../utils/classnames';
import { InterestProvidersContext } from './context';
import { FormattedMessage } from 'react-intl';

export const InterestProviderListItems: FunctionComponent = () => {
  // const [isLoading, setIsLoading] = useState<boolean>(false);
  const [isListLimited, setIsListLimited] = useState<boolean>(true);
  const [hasCalculatorButton, setHasCalculatorButton] = useState<boolean>(true);
  const { interestProviders, setInterestProviders, isLoading, setIsLoading, filters } =
    useContext(InterestProvidersContext);

  useEffect(() => {
    if (filters) {
      setHasCalculatorButton(
        filters.mortgageType === 'Annuiteitenhypotheek' ||
          filters.mortgageType === 'Lineaire_hypotheek'
      );

      const fetchData = async () => {
        setIsLoading(true);
        try {
          fetchInterestProviders(convertFiltersToQueryString(filters)).then((r) => {
            setInterestProviders(r.producten);
            setTimeout(() => {
              setIsLoading(false);
            }, 500);
          });
        } catch (error) {
          console.log(error);
        }
      };

      fetchData();
    }
  }, [filters]);

  return (
    <>
      <div className={`md:grid grid-cols-1 md:grid-cols-8 gap-4 mb-8 hidden`}>
        <div className={`text-center col-span-1 md:col-span-1 font-bold`}>
          <FormattedMessage id={'header.mortgageProviders'} defaultMessage={'Aanbieder'} />
        </div>
        <div
          className={`col-span-3 ${hasCalculatorButton ? 'md:col-span-3' : 'md:col-span-5'}`}></div>
        <div className={`col-span-1 md:col-span-1 font-bold`}>
          <FormattedMessage id={'header.mortgageProduct'} defaultMessage={'Product'} />
        </div>
        <div className={`col-span-1 font-bold`}>
          <FormattedMessage id={'header.interest'} defaultMessage={'Rente'} />
        </div>
        {hasCalculatorButton && <div className={`col-span-1 md:col-span-2`}></div>}
      </div>
      {isLoading && (
        <div className={`flex justify-center my-4 opacity-50`}>
          <Spinner size="md" />
        </div>
      )}
      <div
        className={`${classNames({
          'opacity-50 ': isLoading,
          'fade-bottom': !isLoading && interestProviders.length > 0 && isListLimited
        })} relative`}>
        {isListLimited && !isLoading && interestProviders.length > 0 && (
          <div className={`absolute z-10 -bottom-12 left-0 right-0 text-center`}>
            <Button colorScheme={`blue`} onClick={() => setIsListLimited(false)}>
              <FormattedMessage
                id={'items.button.showAll'}
                defaultMessage={'Toon alle 40 resultaten'}
              />
            </Button>
          </div>
        )}
        {interestProviders
          .slice(0, isListLimited ? 10 : interestProviders.length)
          .map((interestProvider) => (
            <InterestProviderListItem
              key={interestProvider.lookupId}
              selectedMortgageType={filters?.mortgageType}
              selectedEnergyLabel={filters?.energyLabel}
              selectedBuildingType={filters?.buildingType}
              item={interestProvider}></InterestProviderListItem>
          ))}
      </div>
    </>
  );
};
